import { mergeRegister } from '@lexical/utils';
import { $getSelection, COMMAND_PRIORITY_HIGH, LexicalEditor, PASTE_COMMAND } from 'lexical';
import { removeZeroWidthSpace, replaceNonBreakingSpaces } from 'utils/chars';

export const registerCommands = (
  editor: LexicalEditor,
): () => void => {
  return mergeRegister(
    editor.registerCommand<ClipboardEvent>(
      PASTE_COMMAND,
      (event) => {
        const clipboardData = event.clipboardData;
        if (!clipboardData) {
          return false;
        }
        let plainText = clipboardData.getData('text/plain');
        plainText = plainText
          .replace(/\r\n/g, '\n') // Normalize line endings
          .replace(/\n{2,}/g, '\n') // Remove multiple newlines
          .replace(/[ \t]+\n/g, '\n') // Remove trailing spaces before newlines
          .trim();
        plainText = removeZeroWidthSpace(replaceNonBreakingSpaces(plainText));
        if (!plainText) {
          return false;
        }
        const selection = $getSelection();
        if (!selection) {
          return false;
        }
        selection.insertText(plainText);
        event.preventDefault();

        return true;
      },
      COMMAND_PRIORITY_HIGH,
    ));
};

